/**
 * The dashboard SPs hand back either a bare result set (`[...]`) or a single
 * -property document (`{ MetricBranch: [...] }`, `{ DisciplineSummaryValues:
 * [...] }`, …) depending on whether they use `FOR JSON`. The backend passes
 * whichever it got through unchanged, so every table/chart that consumes one of
 * these payloads has to tolerate both shapes.
 *
 * `prefer` names the key to take when the document has several array
 * properties; without it (or when that key is absent) the first array property
 * wins. Non-object entries are dropped, so callers get clean row objects.
 */
export function unwrapRows<T = Record<string, unknown>>(
  data: unknown,
  prefer?: string,
): T[] {
  if (!data || typeof data !== "object") return [];

  let arr: unknown[] = [];
  if (Array.isArray(data)) {
    arr = data;
  } else {
    const obj = data as Record<string, unknown>;
    const named = prefer ? obj[prefer] : undefined;
    if (Array.isArray(named)) {
      arr = named;
    } else {
      for (const v of Object.values(obj)) {
        if (Array.isArray(v)) {
          arr = v;
          break;
        }
      }
    }
  }

  return arr.filter((r): r is T => !!r && typeof r === "object");
}
